















import { defineComponent, reactive, onMounted, computed, watch } from '@vue/composition-api';
import { getStore } from '../store';

const componentName = 'snackbar-popup';

export default defineComponent({
    props: {},
    name: componentName,

    setup(props, context) {
        const store = getStore();

        const state = reactive({
            activeTimeout: -1
        });

        onMounted(() => {
            setTimeout();
        });

        const isActive = computed(() => {
            return store.state.uiSnackbar;
        });

        const propsInternal = computed(() => {
            let s = store.state.uiSnackbar;
            return {
                type: s && s.type,
                message: s && s.message,
                timeout: s && s.timeout || 2000
            }
        });

        const snackbarClasses = computed(() => {
            return {
                'snackbar': true,
                'snackbar--success': propsInternal.value.type == 'success',
                'snackbar--error': propsInternal.value.type == 'error'
            }
        });

        const onClose = () => {
            store.commit('clearUISnackbar');
        }

        const setTimeout = () => {
            window.clearTimeout(state.activeTimeout);

            if (isActive.value && propsInternal.value.timeout) {
                state.activeTimeout = window.setTimeout(() => {
                    onClose();
                }, propsInternal.value.timeout)
            }
        }

        watch(isActive, (isActive, prevIsActive) => {
            setTimeout();
        });

        return {
            state,
            isActive,
            propsInternal,
            snackbarClasses,
            onClose,
            setTimeout
        }
    }
})

